import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/annualAccount'),
  },
	{
	  path: '/gathering',
	  name: 'Gathering',
	  component: () => import('../views/manager/gathering'),
	  meta: {
	    title: '后台收款'
	  },
	},
	{
	  path: '/gatheringRefund',
	  name: 'GatheringRefund',
	  component: () => import('../views/manager/gatheringRefund'),
	  meta: {
	    title: '提交退款'
	  },
	},
	{
	  path: '/annualAccount',
	  name: 'AnnualAccount',
	  component: () => import('../views/annualAccount'),
	  meta: {
	    title: '年度报告'
	  },
	},
	{
	  path: '/vipActivity',
	  name: 'VipActivity',
	  component: () => import('../views/vipActivity'),
	  meta: {
	    title: 'vip活动'
	  },
	},
	{
	  path: '/chatPage',
	  name: 'ChatPage',
	  component: () => import('../views/chatPage'),
	  meta: {
	    title: '客服聊天'
	  },
	},
	{
	  path: '/seventeenArtist',
	  name: 'SeventeenArtist',
	  component: () => import('../views/subject/seventeenArtist'),
	  meta: {
	    title: 'seventeenArtist'
	  },
	},
	
	
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
